import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import AOS from 'aos';
import "./Homepages/Secondpage.css";
import "./Homepages/Homepage1.css";
import Landing from "./pages/Landing";
import Statistics from "./pages/Statistics";
import Services from "./pages/Services";
import Tenders from "./pages/Tenders";
import RTI from "./pages/RTI";
import Gallery from "./pages/Gallery";
import ContactUs from "./pages/ContactUs";
import AboutPage from "./pages/About";
import WarehouseDashboard from "./pages/WarehouseDashboard";
import AdminPage from "./pages/AdminPage";
import Reports from './pages/Reports';
import OtherLinks from './pages/OtherLinks';
import "./App.css";
import NotFound from './pages/NotFound';
import MainLayout from './Config/Mainlayout';
import ManagementOrgChart from './component/ManagementOrgChart';
import WarehouseOrgChart from './component/WarehouseOrgChart';
import ScreenReader from './pages/ScreenReader';
import Disclaimer from './component/FooterLinks/Disclaimer';
import Copyrights from './component/FooterLinks/Copyrights';
import Privacy from './component/FooterLinks/Privacy';
import TermsAndConditions from './component/FooterLinks/TermsAndConditions';
import Accessibility from './component/FooterLinks/Accessibility';
import Hyperlink from './component/FooterLinks/Hyperlink';
import Orgcharts from './component/About/Orgcharts';
import WarehouseOffices from './component/About/WarehouseOffices';
import HeadOffice from './component/About/HeadOffice';
import RegionalOffices from './component/About/RegionalOffices';
import BoardDirectors from './component/About/BoardDirectors';

function App() {

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      easing: 'ease-out-cubic',
    });
  }, []);

  const ProtectedRoute = () => {
    const isAuthenticated = JSON.parse(sessionStorage.getItem("userdetails"));
    const userLoggin = isAuthenticated?.isLoggedIn === true;
    return userLoggin ? <Outlet /> : <Navigate to="/" replace />;
  };

  return (
    <BrowserRouter>
      <div className="d-flex flex-column min-vh-100">
        <main className="flex-grow-1">
          <Routes>
            <Route element={<MainLayout />} >

              {/* <Navbar /> */}
              <Route path="/" element={<Landing />} />
              <Route path="/screen-reader" element={<ScreenReader />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/statistics" element={<Statistics />} />
              <Route path="/services" element={<Services />} />
              <Route path="/tenders" element={<Tenders />} />
              <Route path="/rti" element={<RTI />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/other-links" element={<OtherLinks />} />
              <Route path="/contact-us" element={<ContactUs />} />

              {/* About LINKS */}
              <Route path="/about/board-directors" element={<BoardDirectors />} />
              <Route path="/about/organizational-structure" element={<Orgcharts />} />
              <Route path="/about/head-office" element={<HeadOffice />} />
              <Route path="/about/regional-offices" element={<RegionalOffices />} />
              <Route path="/about/warehouse-offices" element={<WarehouseOffices />} />

              {/* FOOTER LINKS */}
              <Route path="/disclaimer" element={<Disclaimer />} />
              <Route path="/Copyrights" element={<Copyrights />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/hyperlink" element={<Hyperlink />} />
              <Route path="/accessibility" element={<Accessibility />} />
              <Route path="/termsandconditions" element={<TermsAndConditions />} />

              {/* Private  */}
              <Route element={<ProtectedRoute />}>
                <Route path="/warehouse-dashboard" element={<WarehouseDashboard />} />
                <Route path="/warehouse-Admin" element={<AdminPage />} />
                <Route path="/warehouse-Admin/report" element={<Reports />} />
                <Route path="/warehouse-Admin/management-org-chart" element={<ManagementOrgChart />} />
                <Route path="/warehouse-Admin/warehouse-org-chart" element={<WarehouseOrgChart />} />
              </Route>
            </Route>

            {/* notfound */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
      </div>
    </BrowserRouter>

  );
}

export default App;


// import React from 'react';
// import Translate from './pages/Translate';

// function App() {
//   return (
//     <div>
//       <Translate />  {/* Language switcher appears here */}

//       <h1>Welcome to my website</h1>
//       <p>This content will automatically translate to Tamil or English.</p>

//       <h2>About Us</h2>
//       <p>We provide awesome services for everyone.</p>
//     </div>
//   );
// }
// export default App;